<template>
  <div>
    <el-form ref="formRef" :model="greetingForm" label-width="88px">
      <el-form-item label="内容：">
        <el-input :rows="4" type="textarea" v-model="greetingForm.content" placeholder="输入问候语内容" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="sex" placeholder="Select" style="width: 24em">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间：">
        <div style="display: flex">
          <el-time-picker
              v-model="startTime"
              placeholder="开始时间"
              style="width: 9em"
              :disabled="checked"
          />
          &nbsp;&nbsp;-&nbsp;&nbsp;
          <el-time-picker
              v-model="endTime"
              placeholder="结束时间"
              style="width: 9em"
              :disabled="checked"
          />
        </div>
        <el-checkbox
            v-model="checked"
            style="margin-left: 8px;"
        >
          不限
        </el-checkbox>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateGreeting } from "@/api/url";

export default {
  name: "GreetingDialog",
  props: {
    value: Object
  },
  data() {
    return {
      greetingForm: this.value.greetingForm,
      idx: this.value.ids,
      loading: false,

      checked: !this.value.greetingForm.startTime && !this.value.greetingForm.endTime,

      startTime: '',
      endTime: '',

      sexArray: [
        {label: '通用', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.greetingForm.sex?this.value.greetingForm.sex:0,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    noTime() {
      this.startTime = '';
      this.endTime = '';
    },


    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.greetingForm.content) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '内容不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.greetingForm.id?this.greetingForm.id:0;
      param['content'] = this.greetingForm.content;
      param['sex'] = this.sex;
      if ( !this.checked ) {
        param['startTime'] = new Date(this.startTime).toLocaleTimeString();
        param['endTime'] = new Date(this.endTime).toLocaleTimeString();
      }
      postFormData(addOrUpdateGreeting, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
    if ( this.value.greetingForm.startTime ) {
      let date = new Date().toLocaleDateString().split("/")
      let sTime = this.value.greetingForm.startTime.split(":")
      this.startTime = new Date(date[0],date[1],date[2],sTime[0],sTime[1],sTime[2])
      let eTime = this.value.greetingForm.endTime.split(":")
      this.endTime = new Date(date[0],date[1],date[2],eTime[0],eTime[1],eTime[2])
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
